import React from "react";

import "./Input.css";

function Input({value, setValue, style, placeholder, textarea, disabled}) {
    const realSetValue = (e) => {
        if (e.target.value.length === 0 || e.target.value.match(/^[a-zA-Z0-9\s\.,!*+\-|\\/&'"%:;<>=$#@?{}()\\[\\-_]+$/)) {
            setValue(e.target.value);
        }
    };

    if (textarea) {
        return (
            <textarea
                value={value}
                onChange={realSetValue}
                style={style}
                placeholder={placeholder}
                disabled={disabled}
            />
        );
    } else {
        return (
            <input
                value={value}
                onChange={realSetValue}
                style={style}
                placeholder={placeholder}
                disabled={disabled}
            />
        );
    }
}

export default Input;